const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

// Convert English digits (0-9) in any value to Persian digits
export const toPersianDigits = (value) => {
  if (value === null || value === undefined || value === "") return "";
  return String(value).replace(/\d/g, (digit) => PERSIAN_DIGITS[digit]);
};
